<template>
    <div class="admin-token">
        <div class="paca-group">
            <div class="paca-group-list" :class="`list-${index}`" v-for="(item ,index) in tokenList" :key="index" :name="item.id == '' ? 'undefind' : item.id">
                <div class="paca-group-list__header" @click="itemCollapse(index)">
                    <i class="paca-group-list__header-icon"></i>
                    <span class="paca-group-list__header-text">
                        <span class="paca-group-list__header-text-nickname">{{item.id}}</span>
                        <span class="paca-group-list__header-text-length">{{item.result.length}}</span>
                    </span>
                </div>
                <div class="paca-group-list__content">
                    <div class="paca-table">
                        <div class="paca-table__header">
                            <div class="paca-table__header-item item-column column-lock"></div>
                            <div class="paca-table__header-item item-column column-name">名稱({{item.result.length}})</div>
                            <div class="paca-table__header-item item-column column-accounting">帳務</div>
                            <div class="paca-table__header-item item-column column-gate">場務</div>
                            <div class="paca-table__header-item item-column column-cars">車籍</div>
                            <div class="paca-table__header-item item-column column-import">匯入</div>
                            <div class="paca-table__header-item item-column column-config">設定</div>
                            <div class="paca-table__header-item item-column column-create">建立時間</div>
                            <div class="paca-table__header-item item-column column-last-seen">最後使用</div>
                            <div class="paca-table__header-item item-column column-action"></div>
                        </div>
                        <div class="paca-table__body" v-if="tokenList.length > 0">
                            <div class="paca-table__body-col" v-for="(secItem,secIndex) in item.result" :key="secIndex">
                                <div class="paca-table__body-col-list">
                                    <div class="paca-table__body-col-list-item item-column column-lock">
                                        <button class="column-lock-icon" :class="secItem.is_locked==0?'unlock el-icon-unlock':'lock paca-icon-lock'" @click="lockItem(index, secIndex)"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-name overflow-text">{{secItem.name}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-accounting" >
                                        <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_accounting.enable==1)}" @click="changeItemValue(index, secIndex,'priv_accounting')"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-gate" >
                                        <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_gate.enable==1)}" @click="changeItemValue(index, secIndex,'priv_gate')"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-cars" >
                                        <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_car_edit.enable==1)}" @click="changeItemValue(index, secIndex,'priv_car_edit')"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-import">
                                        <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_car_import.enable==1)}"  @click="changeItemValue(index, secIndex,'priv_car_import')"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-config" >
                                        <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_config.enable==1)}" @click="changeItemValue(index, secIndex,'priv_config')"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-create">{{secItem.created_at}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-last-seen">{{secItem.lastseen_at}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-action">
                                        <button class="column-action-button el-icon-document" @click="openItemInfoDialog(secItem)"></button>
                                        <button class="column-action-button el-icon-delete" @click="deleteToken(secItem.name, secItem.email, index, secIndex)"></button>
                                    </div>         
                                </div>
                            </div>
                        </div>
                        <div class="paca-table__empty" v-else>暫無資料</div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog class="admin-token-dialog" :visible.sync="isDialogOpen" v-if="tokenDialogInfo">
            <div slot="title">{{tokenDialogInfo.name}}</div>
            <div class="admin-token-dialog__body">
                <div class="admin-token-dialog__body-item">
                    <div class="admin-token-dialog__body-item-label">建立時間</div>
                    <div class="admin-token-dialog__body-item-value">{{tokenDialogInfo.created_at}}</div>
                </div>
                <div class="admin-token-dialog__body-item">
                    <div class="admin-token-dialog__body-item-label">最後使用</div>
                    <div class="admin-token-dialog__body-item-value">{{tokenDialogInfo.lastseen_at}}</div>
                </div>
            </div>
            <div slot="footer">
                <button type="button" class="admin-token-dialog__footer-button main-button" @click="CloseItemInfoDialog">確認</button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as api from "@/script/apiService/api.js"
import {getFullTime} from "@/script/time/time.js"
export default {
    name: "token",
    data(){
        return{
            tokenList: [],
            isDialogOpen: false,
            tokenDialogInfo: null
        }
    },
    methods: {
        itemCollapse(index){
            if(document.querySelector(`.list-${index}`).classList.contains("is-active")){
                document.querySelector(`.list-${index}`).classList.remove("is-active");
            }else{
                if(document.querySelector(".is-active")){
                    document.querySelector(".is-active").classList.remove("is-active");
                }
                document.querySelector(`.list-${index}`).classList.add("is-active");
            }
        },
        async getAdminTokenList(){
            return await api.getAdminTokenList()
        },
        changeItemValue(groupIndex, itemIndex, itemName){
            this.tokenList[groupIndex].result[itemIndex].cbox_permission[itemName].enable = (this.tokenList[groupIndex].result[itemIndex].cbox_permission[itemName].enable + 1) % 2;
            this.putAdminTokenListItem(groupIndex, itemIndex);
        },
        async lockItem(groupIndex, itemIndex){
            this.tokenList[groupIndex].result[itemIndex].is_locked = (this.tokenList[groupIndex].result[itemIndex].is_locked + 1) % 2;
            if(this.tokenList[groupIndex].result[itemIndex].is_locked == 0){
                await api.putAdminTokenUnLock(this.tokenList[groupIndex].result[itemIndex].email);
            }else{
                await api.putAdminTokenLock(this.tokenList[groupIndex].result[itemIndex].email);
            }
        },
        async putAdminTokenListItem(groupIndex, itemIndex){
            let id = this.tokenList[groupIndex].result[itemIndex].email
            let data = {
                "token_name" : this.tokenList[groupIndex].result[itemIndex].name,
                "token_permission" : [
                    {"name": "priv_accounting","enable": this.tokenList[groupIndex].result[itemIndex].cbox_permission.priv_accounting.enable},
                    {"name": "priv_car_edit","enable": this.tokenList[groupIndex].result[itemIndex].cbox_permission.priv_car_edit.enable},
                    {"name": "priv_car_import","enable": this.tokenList[groupIndex].result[itemIndex].cbox_permission.priv_car_import.enable},
                    {"name": "priv_config","enable": this.tokenList[groupIndex].result[itemIndex].cbox_permission.priv_config.enable},
                    {"name": "priv_gate","enable": this.tokenList[groupIndex].result[itemIndex].cbox_permission.priv_gate.enable},
                ]
            };
            let res = await api.putAdminTokenListItem(id,data);
            if(!res.error_status){

            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
        },
        openItemInfoDialog(item){
            this.tokenDialogInfo = JSON.parse(JSON.stringify(item));
            this.isDialogOpen = true;
        },
        CloseItemInfoDialog(){
            this.isDialogOpen = false;
        },
        deleteToken(token_name, token_email, index, secItemIndex){
            this.$confirm(`即將刪除 ${token_name}`,"刪除權限", {
                confirmButtonText: "確認刪除",
                confirmButtonClass: "main-button",
                cancelButtonText: "取消",
                cancelButtonClass: "second-button",
                type: 'warning'
            }).then(async () => {
                let res = await api.deleteServiceToken(token_email);
                if(!res.error_status){
                    this.tokenList[index].result.splice(secItemIndex,1);
                    if(this.tokenList[index].result.length == 0){
                        this.tokenList.splice(index, 1);
                    }
                }else if(res.error_status != '401' && res.error_status != '504'){
                    this.$message.error({
                        showClose: true,
                        duration: 2500,
                        message: "發生錯誤!"
                    });
                }
            }).catch(() => {})
        }
    },
    async activated(){
        let res = await this.getAdminTokenList();
        if(!res.error_status){
            res.forEach((item) => {
                item.result.forEach((secItem) => {
                    let createTime = null;
                    let lastSeenTime = null;
                    if(secItem.created_at){
                        createTime = getFullTime(new Date(secItem.created_at));
                    } else{
                        createTime = "無";
                    }
                    if(secItem.lastseen_at){
                        lastSeenTime = getFullTime(new Date(secItem.lastseen_at));
                    } else {
                        lastSeenTime = "無";
                    }
                    secItem.created_at = createTime;
                    secItem.lastseen_at = lastSeenTime;
                })
            })
            this.tokenList = res;
        }
    }
}
</script>